import React from 'react';
import './index.css';

function Article() {
  return (
    <div className='columns objetivos'>
      <div className='col'>
        <h4>Objetivos:</h4>
        <ul className='small-list'>
          <li>El objetivo principal del curso es brindar a los 135 municipios bonaerenses las herramientas necesarias para alcanzar un uso más eficiente de los recursos públicos y el acceso a instrumentos financieros.</li>
          <li>Ampliar los conocimientos financieros de las y los funcionarios municipales que intervienen en la administración de los recursos públicos.</li>
          <li>Igualar las posibilidades de acceso a herramientas financieras entre los municipios.</li>
          <li>Fortalecer el rol del Banco como articulador de las necesidades de los municipios en materia económica y financiera.</li>
          <li>Identificar necesidades específicas de los municipios.</li>
        </ul>
      </div>
      <div className='col'>
        <h5>El curso tuvo su primera edición en 2022 y en 2024 se lanzará la segunda con los siguientes módulos:</h5>
        <ul className="modulos">
          <li>
            <h6>Módulo 1</h6>
            <p>Productos y servicios de Banco Provincia</p>
          </li>
          <li>
            <h6>Módulo 2</h6>
            <p>Productos y digitales de Banco Provincia</p>
          </li>
          <li>
            <h6>Módulo 3</h6>
            <p>Provincia Microcréditos</p>
          </li>
          <li>
            <h6>Módulo 4</h6>
            <p>Financiamiento para Pymes</p>
          </li>
          <li>
            <h6>Módulo 5</h6>
            <p>Grupo Provincia</p>
          </li>
          <li>
            <h6>Módulo 6</h6>
            <p>Provincia Servicios Financieros</p>
          </li>
          <li>
            <h6>Módulo 7</h6>
            <p>Estadística Municipal</p>
          </li>
          <li>
            <h6>Módulo 8</h6>
            <p>Herramientas de Vinculación de Banco Provincia</p>
          </li>
        </ul>
        <a href="https://escuelamunicipal.economia.gba.gob.ar/cursos/incluir-municipios-2/" target='_blank' rel='noreferrer' className='btn-verde'>Ingresar</a>
      </div>
      <div className='col empty'>
      </div>
    </div>
  );
}

export default Article;
